import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import { useAuth } from '@/app/context/AuthContext/useAuth';
import { copyToClipboard } from '@/app/utils/stringUtils';
import Image from 'next/image';

import exampleImage from 'public/Anki Settings Wheel Example.png';

export const AnkiGuide = () => {
  const { accessKey, rotateAccessKey, user } = useAuth();
  const { trackEvent, analyticsInstance } = useAnalytics();

  return (
    <div className="cotnainer mb-24 mt-24 flex flex-col items-center justify-center gap-8 rounded p-3 text-center">
      <h1 className="text-2xl font-bold">
        How to instantly generate practice tests from Anki
      </h1>
      <div className="text-lg">
        Step 1: Download the{' '}
        <a
          onClick={() =>
            trackEvent(analyticsInstance, 'anki_practice_guide_click_link')
          }
          className="link link-primary hover:text-base-content"
          href="https://ankiweb.net/shared/info/1881090326"
          target="_blank"
        >
          Limbiks - Practice Test Generator{' '}
        </a>
        (code = 1881090326)
      </div>
      <div className="flex flex-col items-center text-lg">
        <div>
          Step 2: Click the settings wheel next to any deck and select{' '}
          <span className="italic">Practice Test</span>
        </div>
        <Image
          alt="example image"
          className="mt-3"
          width={500}
          src={exampleImage}
        ></Image>
      </div>
      <div className="flex flex-col items-center text-lg">
        <div>
          Step 3: Fill out details and paste your <b>Limbiks Key</b>
        </div>
        {!accessKey && user && (
          <button
            onClick={() => {
              trackEvent(
                analyticsInstance,
                'anki_practice_guide_click_generate_key'
              );
              rotateAccessKey();
            }}
            className="btn mt-4"
          >
            Generate Key
          </button>
        )}
        {accessKey && user && (
          <div className="mt-6 flex gap-2 rounded-lg bg-gray-600 p-4 font-bold">
            {accessKey}
            <button
              onClick={() => {
                trackEvent(
                  analyticsInstance,
                  'anki_practice_guide_click_copy_key'
                );
                copyToClipboard(accessKey);
              }}
              className="tooltip scale-90 cursor-pointer"
              data-tip={'Copy to clipboard.'}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height={24}
                width={24}
                viewBox="0 0 24 24"
              >
                <path
                  fill="white"
                  d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6ZM7 11H13V13H7V11ZM7 15H13V17H7V15Z"
                ></path>
              </svg>
            </button>
            <button
              onClick={() => {
                trackEvent(
                  analyticsInstance,
                  'anki_practice_guide_click_rotate_key'
                );
                rotateAccessKey();
              }}
              className="tooltip scale-90 cursor-pointer"
              data-tip={
                'Click here to generate a new Limbiks Key.  Your existing Limbiks Key will no longer be usable.'
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height={24}
                width={24}
                viewBox="0 0 24 24"
              >
                <path
                  fill="white"
                  d="M12 2C17.5228 2 22 6.47715 22 12C22 14.1364 21.3301 16.1162 20.1889 17.741L17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.1502 20 16.1023 19.1517 17.5398 17.7716L18.5379 19.567C16.7848 21.083 14.4995 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 7C13.6569 7 15 8.34315 15 10V11H16V16H8V11H9V10C9 8.34315 10.3431 7 12 7ZM14 13H10V14H14V13ZM12 9C11.4872 9 11.0645 9.38604 11.0067 9.88338L11 10V11H13V10C13 9.48716 12.614 9.06449 12.1166 9.00673L12 9Z"
                ></path>
              </svg>
            </button>
          </div>
        )}
      </div>
      <div className="flex flex-col items-center text-lg">
        <div>
          <b>Step 4:</b> Start your practice test in Limbiks!
        </div>
      </div>
    </div>
  );
};
